import axios from 'axios';

export default class ProductService {

    filterProdsByKeyContainings(key,values,srt,pageNumber,pageSize,supRefId,additionalFilters) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/product-adhoc/fetch-by-key-containing',
        {
            pageNumber: pageNumber,
            pageSize:pageSize,
            paramKey:key,
            paramValues: values,
            sortByPrice: srt,
            supplierRefId: supRefId,
            additionalFilters: additionalFilters?additionalFilters:null
        }).then(res => res.data);
    }

    filterSortingProds(key, values, sortByPriceDir, sortByRatingDir, pageNumber, pageSize, supRefId, additionalFilters) {
    
            let payload = {
                pageNumber: pageNumber,
                pageSize: pageSize,
                paramKey: key,
                paramValues: values,
                supplierRefId: supRefId,
                additionalFilters: additionalFilters ? additionalFilters : null
            };

            
            if (sortByPriceDir) {
                payload.sortByPrice = sortByPriceDir;
            }
            
            if (sortByRatingDir) {
                payload.sortByProductRatingScore = sortByRatingDir;
            }

            return axios.post(process.env.VUE_APP_API_ROOT + '/product-adhoc/fetch-by-key-containing', payload)
                .then(res => res.data);
        }

	performGuidedSearch(catz,srt,pageNumber,pageSize,supRefId) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/product-adhoc/search-by-guidance',
        {
            pageNumber: pageNumber,
            pageSize:pageSize,
            categories: catz,
            sortByPrice: srt,
            supplierRefId: supRefId
        }).then(res => res.data);
    }

    performTextSearch(txt,pageNumber,pageSize,supRefId) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/product-adhoc/search-by-text',
        {
            pageNumber: pageNumber,
            pageSize:pageSize,
            txt:txt,
            supplierRefId: supRefId
        }).then(res => res.data);
    }

    fetchProductClassifications() {        
        var url=process.env.VUE_APP_API_ROOT+'/product-classifications';
        return axios.get(url).then(res => res.data);
    }

    fetchProductCategories(supRefId) {
        //console.log("fetching prod category from "+supRefId);        
        var url=process.env.VUE_APP_API_ROOT+'/product-adhoc/fetch-prod-categories/'+supRefId;
        return axios.get(url).then(res => res.data);
    }

    fetchProductCategoriesByClassification(supRefId,classification) {
        //console.log("fetching prod category from "+supRefId);        
        var url=process.env.VUE_APP_API_ROOT+'/product-adhoc/fetch-categories-by-classification';
        return axios.post(url,{
            supplierRefId: supRefId,
            classification: classification
        }).then(res => res.data);
    }

    fetchProduct(supRefId,prodRefId) {
        //console.log("fetching prod category from "+supRefId);        
        var url=process.env.VUE_APP_API_ROOT+'/product-adhoc/fetch-prod/'+supRefId+'/'+prodRefId;
        return axios.get(url).then(res => res.data);
    }

    fetchProductClasses(){
        var url=process.env.VUE_APP_API_ROOT+'/product-classifications/fetch-all';
        return axios.get(url).then(res => res.data);
    }
}
